export const addGtag = (trackCode:any) => {
 if(document.head && trackCode && trackCode.tagId && 
   (undefined !== process.env.REACT_APP_ENV && process.env.REACT_APP_ENV.startsWith('prod')) ){
	  
	  const script = document.createElement("script");
	  script.src = "https://www.googletagmanager.com/gtag/js?id="+trackCode.tagId;
	  script.async = true;
	  document.head.appendChild(script);
	  
	  const script1 = document.createElement("script");
	  script1.innerHTML ="window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag('js', new Date());gtag('config', '"+trackCode.tagId+"');";
	  document.head.appendChild(script1);
  }
}

export const addGtagEvent = (trackCode:any, source:any) => {
 if(document.head && trackCode && trackCode.eventName && 
   (undefined !== process.env.REACT_APP_ENV && process.env.REACT_APP_ENV.startsWith('prod')) ){
	  
	  const script1 = document.createElement("script");
	  var data = trackCode?.eventData;
	  if (data && source) {
        Object.keys(source).forEach(function (key) {
          data = data.replace("%"+key.toUpperCase()+"%", "'"+source[key]+"'");
        });
      }
      
	  script1.innerHTML ="gtag('event', '"+trackCode.eventName+"', "+data+");";
	  document.head.appendChild(script1);
  }
}

export const addTrackingCode = (tenantHeader, env) => {
  if('12CF4BRD' ===  tenantHeader && (undefined !== env && env.startsWith('prod')) ){
	  
	  const script = document.createElement("script");
	  script.src = "https://www.googletagmanager.com/gtag/js?id=G-FEMHEXF8H6";
	  script.async = true;
	  document.head.appendChild(script);
	  
	  const script1 = document.createElement("script");
	  script1.innerHTML ="window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag('js', new Date());gtag('config', 'G-FEMHEXF8H6');";
	  document.head.appendChild(script1);
  }
}

export const triggerConfirmEvent = (tenantHeader, env, bookingId, total) => {
  if('12CF4BRD' ===  tenantHeader && (undefined !== env && env.startsWith('prod')) ){
	  const script1 = document.createElement("script");
	  
	  script1.innerHTML ="gtag('event', 'conversion', {'send_to': 'AW-830511902/NZnoCL3PuK0ZEJ62gowD','value': "+total+",'currency': 'USD','transaction_id': "+bookingId+"});";
	  document.head.appendChild(script1);
  }
}